import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'EntrySheetConfirmCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})